module.exports = __webpack_public_path__ + "img/chat.58e41f9b.svg";